// extracted by mini-css-extract-plugin
module.exports = {"title-wrap":"title-wrap__1Vx5Y","titleWrap":"title-wrap__1Vx5Y","title":"title__hurun","border":"border__3z9j8"};